module.exports = __webpack_public_path__ + "img/no-navigations.a140ba79.svg";